module.exports = __webpack_public_path__ + "img/ic_mainservice_phone_header.b1bba5cd.svg";